import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error4',
  templateUrl: './error4.component.html',
  styleUrls: ['./error4.component.css']
})
export class Error4Component implements OnInit {
   code:String = ` }, err => { <br>
     this.navCtrl.push(ErrorPage, {message: "errorPaginar", error: err, page: this.navCtrl.getActive().name}); <br>
   }); `;

   code2:string = `notifError(strError, this.page){<br>
      this.db.collection("errors").add({uidUser: uidUser, page: page, eror: error, fecha: this.fechaActual()});<br>
   }`

   code3:string = "{{ 'ERRORES.' + translate | translate }}";

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Errores/error4/error4.component.ts